import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, LockKeyhole } from "lucide-react";
import { formatTenantFeature, formatTenantPlan } from "@/lib/tenantBillingAccess";
import { useFeatures } from "@/context/FeaturesContext";

export default function Upgrade() {
  const [params] = useSearchParams();
  const { packageSegment } = useFeatures();
  const feature = params.get("feature") || "";
  const requiredPlan = params.get("required_plan") || "clinic";
  const featureLabel = formatTenantFeature(feature);

  return (
    <section className="mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-8 text-slate-950 shadow-sm">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-slate-950 text-white shadow-sm">
          <LockKeyhole className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
            Upgrade required
          </p>
          <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-950">
            Upgrade to {formatTenantPlan(requiredPlan)} to unlock {featureLabel}
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
            {featureLabel} is not included in this tenant&apos;s {packageSegment || "current"} package. Plan and feature changes apply on the tenant&apos;s next login.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/settings/billing"
              className="inline-flex items-center gap-2 rounded-lg bg-slate-950 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-800"
            >
              Upgrade plan
              <ArrowUpRight className="h-4 w-4" />
            </Link>
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to dashboard
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
